<template>
    <div class="featurebadge">
        <div class="line-1">{{lines[0] || ''}}</div>
        <div class="line-2">{{lines[1] || ''}}</div>
        <div class="line-3">{{lines[2] || ''}}</div>
    </div>
</template>
<script>
export default {
    props: {
        text: String
    },
    computed: {
        lines: function() {
            return this.text.split("\n");
        },
    }
}
</script>
